module.exports = __webpack_public_path__ + "img/1472938129.7d95e57d.jpg";